module.exports = __webpack_public_path__ + "static/work-hard-be-nice-4bf8b318a499dd168437a0db920e2d44.jpg";